
export const getClassNameGenerator = (baseClass) => (className, asSubClass, subClass = '') => (
  asSubClass
    ? (subClass ? `${baseClass}--${className}__${subClass}` : `${baseClass}__${className}`)
    : `${baseClass}--${className}`
);
